import { createContext, useContext } from "react";
import type { Supplier } from "../types/supplier.types";

interface SupplierOverviewContextType {
  supplier: Supplier | null;
  refetch: () => Promise<void>;
}

const SupplierOverviewContext = createContext<SupplierOverviewContextType | null>(null);

export const useSupplierOverview = () => {
  const context = useContext(SupplierOverviewContext);
  if (!context) {
    throw new Error("useSupplierOverview must be used within provider");
  }
  return context;
};

export default SupplierOverviewContext;
